import { useHasPermission as useSharedHasPermission, type UseHasPermissionResult, type UnitPermissionActions } from "@scoutingops/security";

import { useSupabaseClient } from "@/hooks/use-supabase-client";

export type { UseHasPermissionResult };

/** Thin binding of @scoutingops/security's shared useHasPermission() to this app's own useSupabaseClient() — same pattern as scoutingops-hub's use-has-permission.ts. */
export function useHasPermission(featureKey: string, action: keyof UnitPermissionActions): UseHasPermissionResult {
  const getSupabase = useSupabaseClient();
  return useSharedHasPermission(getSupabase, featureKey, action);
}
